/**
 * 岗位级别接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JobManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
   ) {
   }

  //#region 岗位级别接口
  /**
   * 分页查询岗位级别
   * @param param
   * @returns {Observable<any>}
   */
  queryJobPageList(param) {
    const url = this.prefix + 'job/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除岗位级别
   * @param param
   * @returns {Observable<any>}
   */
  deleteJob(param) {
    const url = this.prefix + 'job/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 修改岗位级别
   * @param param
   * @returns {Observable<any>}
   */
  updateJob(param) {
    const url = this.prefix + 'job/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 新增岗位级别
   * @param param
   * @returns {Observable<any>}
   */
  saveJob(param) {
    const url = this.prefix + 'job/save';
    return this.http.Post(url, param);
  }

  /**
   * 查询单个岗位级别信息
   * @param param
   */
  getJob(param) {
    const url = this.prefix + 'job/queryById';
    return this.http.Post(url, param);
  }

  //#endregion



}
